import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { userState, defaultUser } from "@fuse/recoil/signup";
import { eventEmitter } from "@fuse/utils/eventEmitter";

const UserStateUpdater: React.FC = () => {
  const [user, setUser] = useRecoilState(userState);

  useEffect(() => {
    const handleResetUserState = () => {
      setUser(defaultUser);
    };

    eventEmitter.on("resetUserState", handleResetUserState);

    return () => {
      eventEmitter.off("resetUserState", handleResetUserState);
    };
  }, [setUser]);

  return null;
};

export default UserStateUpdater;
